<template>
  <div class="row vh-100">
    <div class="col-5" style="border-right: 1px solid #e0e0e0">
      
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Summary">
          
          <a-descriptions title="Receiving Details" layout="horizontal" size="small" bordered>
            <a-descriptions-item label="Batch #" span="2"> {{ this.cardReceiveData.batch_number }} </a-descriptions-item>
            <a-descriptions-item label="Supplier" span="2"> {{ this.cardReceiveData.supplier.name}} </a-descriptions-item>
            <a-descriptions-item label="Membership Program" span="3">{{ this.cardReceiveData.membershipProgram.name }} | {{ this.cardReceiveData.membershipLevel.name }}</a-descriptions-item>
            <!-- <a-descriptions-item label="Membership Level" span="2">{{ this.cardReceiveData.membershipLevel.name }}</a-descriptions-item> -->
            <a-descriptions-item label="Card Type" span="3">{{ this.cardReceiveData.cardType.name }}</a-descriptions-item>
            <a-descriptions-item label="Target Site" span="3">{{ this.cardReceiveData.site.name }}</a-descriptions-item>
            <a-descriptions-item label="Status" span="3">
              <a-tag v-if="this.cardReceiveData.cardOrderStatus.name == 'Posted'" color="#87d068">{{ this.cardReceiveData.cardOrderStatus.name.toUpperCase() }}</a-tag>
              <a-tag v-else color="#ff9d5c">{{ this.cardReceiveData.cardOrderStatus.name.toUpperCase() }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="Created By" span="2">{{ this.cardReceiveData.createdBy.name }}</a-descriptions-item>
            <a-descriptions-item label="Approved By" span="2">{{ this.cardReceiveData.approvedBy.name }}</a-descriptions-item>
          </a-descriptions>

          <br> 
          
          <a-descriptions title="Card Count Summary" layout="horizontal" size="small" bordered>
            <a-descriptions-item label="Total Quantity" span="6">{{ this.cardReceiveData.fullCardDetails.length }}</a-descriptions-item>
            <a-descriptions-item label="Received" span="6">{{ this.cardListGrouped["Received"] ? this.cardListGrouped["Received"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="In-Transit from Supplier" span="6">{{ this.cardListGrouped["Ordered"] ? this.cardListGrouped["Ordered"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="In-Transit to Branch" span="6">{{ this.cardListGrouped["In-Transit"] ? this.cardListGrouped["In-Transit"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Activated" span="6">{{ this.cardListGrouped["Activated"] ? this.cardListGrouped["Activated"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Used" span="6">{{ this.cardListGrouped["Assigned"] ? this.cardListGrouped["Assigned"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Deactivated" span="6">{{ this.cardListGrouped["Deactivated"] ? this.cardListGrouped["Deactivated"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Rejected" span="6">{{ this.cardListGrouped["Rejected"] ? this.cardListGrouped["Rejected"].length : 0 }}</a-descriptions-item>
          </a-descriptions>
        </a-tab-pane>

        <a-tab-pane key="2" tab="For Receive" force-render v-if="cardReceiveData.cardOrderStatus.status_code == 'ORDER_RECEIVE'">
          <a-table size="small"
            class="ant-table-striped"
            :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped-2' : null)"
            :dataSource="cardListGrouped['Ordered'] ? cardListGrouped['Ordered'] : []"
            :columns="cardDisplayColumns"
          />
        </a-tab-pane>

      </a-tabs>
    
    </div>

     <!-- v-if="transferInData.transferStatus.status_code == 'TRANSFER_INTRANSIT'" -->
    <div class="col-7" v-if="cardReceiveData.cardOrderStatus.status_code == 'ORDER_RECEIVE'">
      <h6 class="heading-small text-muted mb-4 text-truncate">
        <span>Receive Card Order</span>
      </h6>

      <form id="form-proper" @submit.prevent="noop">
        <div class="py-2" style="border-bottom: 1px solid #e0e0e0;">
          <div class="row mb-3">
            <div class="col">
              <a-radio-group v-model="receiveBy" @change="onChange">
                <a-radio
                  v-for="option in receivingOptions"
                  :style="radioStyle"
                  :key="option.key"
                  :value="option.key"
                >
                  {{ option.value }}
                </a-radio>
              </a-radio-group>
            </div>
          </div>

          <!-- Card Number -->
          <div class="row" v-if="receiveBy == 'card_number'">
            <div class="col">
              <base-input label="Enter Card No." required>
                <a-input v-model="cardNumber" @keypress.enter="addData()"/>
              </base-input>
            </div>
          </div>

          <!-- Series Number -->
          <div class="row" v-if="receiveBy == 'range'">
            <div class="col">
              <base-input label="From" required>
                <a-input v-model="serialNoFrom" />
              </base-input>
            </div>
            <div class="col">
              <base-input label="To" required>
                <a-input v-model="serialNoTo" />
              </base-input>
            </div>
          </div>

          <div class="row" v-if="receiveBy != 'batch'">
            <div class="col">
              <b-button
                size="sm"
                class="float-md-right success"
                @click.prevent="addData"
              >
                Add
              </b-button>
            </div>
          </div>

          <br><br>

          <div class="row">
            <div class="col">
              <a-table size="small"
                class="ant-table-striped"
                :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped-2' : null)"
                v-if="receiveBy == 'card_number'"
                :dataSource="cardsFull"
                :columns="cardDisplayColumns"
              />

              <a-table size="small"
                class="ant-table-striped"
                :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped-2' : null)"
                v-if="receiveBy == 'range'"
                :dataSource="cardRange"
                :columns="cardRangeColumns"
              />

              <!-- <a-table v-if="receiveBy == 'card_number'" :dataSource="cards" :columns="cardColumns" /> -->
              <!-- <a-table v-if="receiveBy == 'range'" :dataSource="cardRange" :columns="cardRangeColumns" /> -->
            </div>
          </div>

        </div>

        <br><br><br>

        <div
          style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;"
        >
          <div class="container mx-0 px-0">
            <div class="row">
              <div class="col-auto mr-auto">
                <b-button
                  size="sm"
                  class="float-md-left"
                  style="margin-left: 8px"
                  @click.prevent="closeOptionDrawer"
                >
                  Cancel
                </b-button>
              </div>
              <div class="col-auto">
                <template>
                  <a-spin :spinning="formSubmitting">
                    <div
                      v-if="
                        cardReceiveData.cardOrderStatus.status_code ==
                          'ORDER_RECEIVE'
                      "
                    >
                      <b-button
                        size="sm"
                        variant="primary"
                        @click.prevent="receiveCheck"
                        :disabled="cardReceiveData == null"
                      >
                        Receive
                      </b-button>


                    <a-popconfirm v-if="receiveBy == 'batch'" 
                        title="This will change status of all unreceived cards to Rejected. Are you sure you want to proceed posting this order?" 
                        @confirm="() => postReceive()">
                      <a style="color: white;" class="btn btn-sm btn-success">Post</a>
                    </a-popconfirm>
                      
                      <!-- <b-button
                        v-if="receiveBy == 'batch'"
                        size="sm"
                        variant="warning"
                        @click.prevent="postReceive"
                        :disabled="cardReceiveData == null"
                      >
                        Post
                      </b-button> -->

                    </div>
                  </a-spin>
                </template>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-7" v-else>
        <a-tabs default-active-key="1">
          <a-tab-pane key="1" tab="Card List">
            <a-table 
              class="ant-table-striped"
              size="small"
              :columns="cardDisplayColumnsFull"
              :data-source="cardReceiveData.fullCardDetails"
              :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped-2' : null)"
            />
          </a-tab-pane>
        </a-tabs>
        <br>
    </div>

  </div>
</template>

<script>
import _ from 'lodash';
import HTTPRequest from '../../controllers/httpRequest';
import secureStorage from '../../controllers/secureStorage';

export default {
  name: 'CardReceiveOptionForm',
  props: {
    cardReceiveData: Object,
    viewMode: Boolean
  },
  data() {
    return {
      cardListGrouped: {},
      formSubmitting: false,
      receiveBy: 'batch',
      currentSiteId: secureStorage.getItem('currentSiteId'),
      receivingOptions: [
        {
          key: 'batch',
          value: 'Batch'
        },
        {
          key: 'card_number',
          value: 'Card No.'
        },
        {
          key: 'range',
          value: 'Serial  No. Range'
        }
      ],
      cards: [],
      cardRange: [],
      cardsFull: [],
      cardColumns: [ { title: "Card Number/s" } ],
      cardDisplayColumnsFull: [
        { title: 'Card Type', key: 'card_type_name', dataIndex: 'card_type_name',},
        { title: 'Serial Number', key: 'serial_no', dataIndex: 'serial_no' },
        { title: 'Card Number', key: 'card_number', dataIndex: 'card_number' },
        { title: 'Status', key: 'card_status_name', dataIndex: 'card_status_name' },
      ],
      cardDisplayColumns: [
        { title: 'Card Type', key: 'card_type_name', dataIndex: 'card_type_name',},
        { title: 'Serial Number', key: 'serial_no', dataIndex: 'serial_no' },
        { title: 'Card Number', key: 'card_number', dataIndex: 'card_number' },
      ],
      cardRangeColumns: [ { title: "From",  key: 'from', dataIndex: 'from', }, { title: "To",  key: 'to',  dataIndex: 'to'}, { title: "Valid Card Count",  key: 'count', dataIndex: 'count' } ],
      cardNumber: null,
      serialNoFrom: null,
      serialNoTo: null,
      serialNo: null,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      }
    };
  },
  methods: {

    noop(){
      console.log("Prevent");
    },

    async addData(){
      if(this.receiveBy == 'card_number'){
        this.validateCards(this.cardNumber)
      } else if (this.receiveBy == 'range'){
        this.validateRange(this.serialNoFrom, this.serialNoTo)
      }
    },

    async receiveCheck() {
      if(this.receiveBy == "batch")
        await this.receiveCards()
      else  
        await this.partialReceiveCards()
    },

    async postReceive(){
      console.log("Handle posting :D ")
      this.formSubmitting = true;
      const response = await HTTPRequest.putRequest(
        '/api/v1/clp_card_orders/' +
          this.cardReceiveData.batch_number +
          '/post?origin_site_id=' +
          this.currentSiteId,
        {
          card_order: {
            membership_program_id: this.cardReceiveData.membership_program_id
          }
        }
      );

      if (response.id) {
        this.closeOptionDrawer();
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Order has been posted.'
        });
      } else {
        this.$notification.error({
          message: 'Error',
          description: response.error ?? 'Something went wrong. Please try again.',
          placement: 'topLeft'
        });
      }

      this.formSubmitting = false;
    },

    async validateCards(card_number) {
      this.formSubmitting = true;
      const response = await HTTPRequest.getRequest(
        '/api/v1/cards/validateCardForReceive/' + card_number + "?batch=" + this.cardReceiveData.batch_number
      );

      if (response.id) {
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Card is valid'
        });
        this.cards.push(this.cardNumber)
        this.cards = this.cards.filter((x, i) => i === this.cards.indexOf(x))
        this.cardsFull.push({card_number: response.card_number, serial_no: response.serial_no, card_type_name: response.cardType.name})
        this.cardsFull = _.uniqWith(this.cardsFull, _.isEqual);
        this.cardNumber = null
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Card is invalid.'
        });
      }
      this.formSubmitting = false;
    },

    async validateRange(from, to) {
      // console.log(from + "--" + to);
      this.formSubmitting = true;
      const response = await HTTPRequest.postRequest(
        '/api/v1/cards/validateCardRangeForReceive/',
        {
          from: from,
          to: to,
          batch_number: this.cardReceiveData.batch_number
        }
      );

      if (response.length > 0) {
        this.$notification.success({
          message: 'Success',
          description: 'Serial Range is valid. Valid card count: ' + response.length
        });

        for(var i = 0; i < response.length; i ++){
          this.cards.push(response[i].card_number)
          this.cards = this.cards.filter((x, i) => i === this.cards.indexOf(x))
        }
        this.serialNoTo = null
        this.serialNoFrom = null
        this.cardRange.push({key: (this.cardRange.length + 1), from: from, to: to, count: response.length})

      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Serial Range is invalid.'
        });
      }
      this.formSubmitting = false;
    },

    async receiveCards() {
      this.formSubmitting = true;
      const response = await HTTPRequest.putRequest(
        '/api/v1/clp_card_orders/' +
          this.cardReceiveData.batch_number +
          '/receive?origin_site_id=' +
          this.currentSiteId,
        {
          card_order: {
            membership_program_id: this.cardReceiveData.membership_program_id
          }
        }
      );

      if (response.id) {
        this.closeOptionDrawer();
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Card has been received.'
        });
      } else {
        this.$notification.error({
          message: 'Error',
          description: response.error ?? 'Something went wrong. Please try again.',
          placement: 'topLeft'
        });
      }

      this.formSubmitting = false;
    },

    async partialReceiveCards() {
      this.formSubmitting = true;

      const response = await HTTPRequest.putRequest(
        '/api/v1/clp_card_orders/' +
          this.cardReceiveData.batch_number +
          '/partial_receive?origin_site_id=' +
          this.currentSiteId,
        {
          type: this.receiveBy,
          card_order: {
            membership_program_id: this.cardReceiveData.membership_program_id,
            cards: this.cards
          }
        }
      );

      if (response.id) {
        this.closeOptionDrawer();
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Card has been received.'
        });
      } else {
        this.$notification.error({
          message: 'Error',
          description: response.error ?? 'Something went wrong. Please try again.',
          placement: 'topLeft'
        });
      }

      this.formSubmitting = false;
    },

    populateCardRange(from, to) {
      for (let i = from; i <= to; i++) {
        this.cards.push(i);
      }
    },

    onChange() {
      this.cards = [];
      this.cardsFull = [];
      this.serialNoFrom = null;
      this.serialNoTo = null;
      this.serialNo = null;
      this.cardNumber = null;
    },

    clearForm() {
      this.receiveBy = 'batch';
      this.cardsFull = [];
      this.cards = [];
      this.serialNoFrom = null;
      this.serialNoTo = null;
      this.serialNo = null;
      this.cardNumber = null;
    },

    closeOptionDrawer() {
      this.clearForm();
      this.$emit('closeOptionDrawer', null);
    }
  },
  mounted() {

    this.cardListGrouped = _.groupBy(this.cardReceiveData.fullCardDetails, card => card.card_status_name);
    // console.log("****************");
    // console.log(this.cardListGrouped);

    // console.log("---------------------")
    // console.log(this.cardReceiveData)
  }
};
</script>

<style scoped></style>
